<template>
  <CardSection :loading="isSavableStateLoading" :error="majorError">
    <template #header>
      Manage Checklist Template Categories
    </template>

    <template #body>
      <div class="form-group row">
        <div class="form-group mr-2 mb-0 col-12 d-flex">
          <router-link :to="{ name: 'admin_checklist_template_categories_new' }" class="btn btn-primary btn-sm ml-auto">
            Add New Category
          </router-link>
        </div>
      </div>

      <PortalTable table-id="template_categories_index" 
        :table-data="records"
        :total-records="totalRecords"
        :page="pageNumber"
        :page-count="pageCount"
        :loading="isSavableStateProcessing"
        :filter-values="filterValues"
        filter-display="row"
        empty="No Template categories found!"
        @on-sort="handleSortChange"
        @on-page="handlePageChange"
        @on-filter-change="onFilterChange">
        <template #columns>
          <Column field="category_name" header="Category Name" sortable
            filter-field="category_name" 
            :show-filter-menu="false">
            <template #filter="{ filterModel = { value: null }, filterCallback }">
              <InputText v-model="filterModel.value"
                type="text"
                class="p-column-filter"
                placeholder="Search by Category Name"
                @input="filterCallback()" />
            </template>
          </Column>
          <Column field="created_by.full_name" 
            header="Created By" 
            sortable />
          <Column field="updated_by.full_name" 
            header="Last Edited By" />
          <Column header="Actions">
            <template #body="slotProps">
              <router-link :to="{ name: 'admin_checklist_template_categories_edit', params: { id: slotProps.data.id } }"
                class="action btn btn-fill btn-outline-primary mx-2">
                Edit
              </router-link>
            </template>
          </Column>
        </template>
      </PortalTable>
    </template>
  </CardSection>
</template>

<script lang="ts">
import CardSection from "@/src/components/shared/CardSection.vue";
import PortalTable from "@/src/components/shared/PortalTable.vue";
import Column from 'primevue/column';
import { useChecklistStore } from '@/src/stores/checklist';
import { savableStateMixin } from "@/src/mixins/savableStateMixin";
import { pageMixin } from "@/src/mixins/pageMixin";
import { paginationMixin } from "@/src/mixins/paginationMixin";
import { FilterMatchMode } from '@primevue/core/api';
import InputText from 'primevue/inputtext';

export default {
  components: {
    CardSection,
    PortalTable,
    Column,
    InputText
  },
  mixins: [ savableStateMixin, pageMixin, paginationMixin ],
  setup() {
    const checklistStore = useChecklistStore();
    return {
      checklistStore
    }
  },
  data() {
    return {
      filterValues: {
        "category_name": { value: null, matchMode: FilterMatchMode.STARTS_WITH }
      }
    }
  },
  async mounted() {
    await this.getRowData();
  },
  methods: {
    async getRowData(reset = false) {
      this.setSavableStateProcessing();
      if (reset) this.pageNumber = 1;
      
      let params = {
        page: this.pageNumber,
        sort_by: this.currentSortField,
        sort_type: this.currentSortType,
      };
      params = { ...this.search_params, ...params };
      try {
        const response = await this.checklistStore.loadPaginatedCategories(params);
        this.processPagyResponse(response);
        this.setSavableStateIdle();
      } catch(error) {
        this.handleMajorError(error);
      }
    },
    onFilterChange(event) {
      this.search_params = event;
      this.getRowData(true);
    },
  }
}
</script>
